import React from 'react';
import usaStates from 'app/data/common/usaStates';
import XGSFormInput from 'ui-components/form/input/xgsFormInput';
import XGSFormSelect from 'ui-components/form/select/xgsFormSelect';
import { LabelModes } from 'ui-components/molecules/labeled-inputs/labeledInput';

const Address = () => {
  return (
    <div className='drivers-sidebar__address'>
      <XGSFormInput
        type="text"
        name="street"
        required={true}
        labelMode={LabelModes.column}
        label="Street Address"
      />
      <div className='drivers-sidebar__address__row'>
        <XGSFormInput
          type="text"
          name="city"
          required={true}
          labelMode={LabelModes.column}
          label="City"
        />
        <XGSFormSelect
          label="State/Province"
          name="state"
          required={true}
          options={usaStates}
          // value={cdlClassOptions.find(option => option.value ===
          //   driverState.selectedDriver?.commercialDriverLicense?.licenseClass)}
          formik
          labelMode={LabelModes.column}
          className=''
        />
      </div>
      <div className='drivers-sidebar__address__row'>
        <XGSFormInput
          type="text"
          name="zipcode"
          required={true}
          labelMode={LabelModes.column}
          label="ZIP/Postal Code"
        />
      </div>
    </div>
  );
};

export default Address;
